export function setPosts(state,data) {
    state.categoria_id = data.categoria_id;
    state.titulo = data.titulo;
    state.tipo = data.tipo;
    state.fecha_publicacion = data.fecha_publicacion;
    state.min_fecha_publicacion = data.min_fecha_publicacion;
    state.max_fecha_publicacion = data.max_fecha_publicacion;
    state.activo = data.activo;
    state.fijo = data.fijo;
    state.paginate = data.paginate;
    state.items_to_show = data.items_to_show;
    state.order = data.order;
    state.order_by = data.order_by;
}

export function setPost(state,data){
    state.id = data.id;
    state.categoria_id = data.categoria_id;
    state.titulo = data.titulo;
    state.introduccion = data.introduccion;
    state.descripcion = data.descripcion;
    state.imagen = data.imagen;
    state.tipo = data.tipo;
    state.fecha_publicacion = data.fecha_publicacion;
    state.activo = data.activo;
    state.fijo = data.fijo;
}

export function clearPost(state){
    state.id = null;
    state.categoria_id = null;
    state.titulo = "";
    state.introduccion = ""; 
    state.descripcion = "";
    state.imagen = "";
    state.tipo = "";
    state.fecha_publicacion = ""; 
    state.activo = true;
    state.fijo = false;
}

export function setPostsByCategory(state,categoria_id) {

    state.categoria_id = categoria_id;
}

export function setPostsByTitle(state,titulo) {

    state.titulo = titulo;
}
